/**
 * Created by yuanlei on 2019/12/10.
 */
/**
 * 接口域名的管理
 */
const base = {
  login: '/ap', //根域名代理
  supply: '/ap/api/supply', //用户信息接口代理
  logisticsTool: '/ap/logistics/tool', //忘记密码接口代理
  logistics: '/ap/logistics', //返回单接口
  baseImgUrl: 'https://api.zhonggang365.com' //线上正式图片地址
  // baseImgUrl: 'http://lms.zhonggang56.cn' ,//测试开发图片地址
  // baseImgUrl: 'http://192.168.254.82:6060' ,//本地测试开发图片地址
}

export default base;



// WEBPACK FOOTER //
// ./src/api/base.js